import React from 'react';

import styles from './TabSelector.module.css';

export default ({ activeTab, setActiveTab, options }) => (
  <div className={styles.container}>
    {options.map((o, i) => (
      <div
        className={
          activeTab === o.value
            ? `${styles.item} ${styles.active}`
            : styles.item
        }
        key={`${i.toString()}-option-item`}
        role="presentation"
        onClick={() => setActiveTab(o.value)}
      >
        {o.label}
      </div>
    ))}
  </div>
);
